import styled from 'styled-components';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 42px;
    border-bottom: 1px solid rgba(219, 219, 219, 1);
    padding-bottom: 34px;

    .price {
        font-family: 'Montserrat';
        font-size: 16px;
        color: rgba(64, 55, 57, 1);
        text-align: left;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }

    @media screen and (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: center;
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/OrderSummary/Wrapper.js